module.exports = __webpack_public_path__ + "static/media/carrortDown.3fc40b5b.svg";